const API_URL = "https://lets-manage-7d2ea4f309ff.herokuapp.com"; 

export async function createTraining(username, idT, trainingData) {
    if (!username) {
        throw new Error('Username not found in localStorage');
    }
    const url = `${API_URL}/users/${username}/teams/${idT}/trainings`;

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(trainingData),
        });

        const contentType = response.headers.get("content-type");
        let responseBody;

        if (contentType && contentType.includes("application/json")) {
            responseBody = await response.json();
        } else {
            responseBody = await response.text();
        }

        if (!response.ok) {
            if (responseBody.errors) {
                const errorMessages = responseBody.errors.map(err => `${err.field}: ${err.message}`).join('\n');
                throw new Error(`API Error: ${errorMessages}`);
            } else {
                throw new Error(responseBody.message || `Error creating training with status ${response.status}`);
            }
        }
        return responseBody;
    } catch (error) {
        console.error("Error in createTraining:", error);
        throw error;
    }
}